// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","link":"Header_link__xIhZh","linkspacer":"Header_linkspacer__zqMBC","homelink":"Header_homelink__yW1zp"};